module.exports = __webpack_public_path__ + "static/img/ge.16f859b5.svg";